import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import datePicker from '../../component/datePicker.vue'
import moment from 'moment'

require('bootstrap')

if ($('#purchase_material_report').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#purchase_material_report',
    components: {
      datePicker
    },
    mixins: [mixins],
    data: {
      dateFrom: moment().locale('pl').format('YYYY-MM-DD'),
      dateTo: moment().locale('pl').format('YYYY-MM-DD'),
    },
    methods: {
      generateXls() {
        $(location).attr('href', Routing.generate('generate_purchase_material_report_xls', {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        }))
      }
    },
  })
}
